import { useState } from "react";
import { useLoaderData } from "react-router-dom";
import { motion } from "framer-motion";

import CarListRedesign from "./CarListRedesign";
import FilterRedesign from "./FilterRedesign";

export default function HomeRedesign() {
  document.title = "FORD - Редизайн (тест)";

  const cars = useLoaderData();
  const [x, setX] = useState("-100vw");

  function closeFilter() {
    setX("100vw");
    setTimeout(() => {
      setX("-100vw");
    }, 300);
  }

  return (
    <>
      <div className="grid min-h-screen grid-cols-4 overflow-hidden">
        <motion.div
          className="fixed top-0 left-0 z-50 w-4/5 h-full bg-white shadow-lg lg:hidden"
          initial={{ x }}
          animate={{ x }}
          transition={{ duration: 0.2, type: "tween" }}
        >
          {cars && <FilterRedesign cars={cars} closeFilter={closeFilter} />}
        </motion.div>

        <div className="z-50 hidden h-full col-span-1 w-80 lg:block">
          {cars && <FilterRedesign cars={cars} />}
        </div>

        <div className="z-0 col-span-3">
          {cars && <CarListRedesign cars={cars} />}
        </div>
      </div>
    </>
  );
}
